import { render, staticRenderFns } from "./EmployeeProfile.vue?vue&type=template&id=15ddf74f&scoped=true"
import script from "./EmployeeProfile.vue?vue&type=script&lang=js"
export * from "./EmployeeProfile.vue?vue&type=script&lang=js"
import style0 from "./EmployeeProfile.vue?vue&type=style&index=0&id=15ddf74f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ddf74f",
  null
  
)

export default component.exports